import type { Teacher } from '../types'

export type OpenTeacherDetailsOptions = {
  /** When false, hide "Mark as Non-Active" (e.g. education qualification review). Default true. */
  allowMarkNonActive?: boolean
  /** If set (same-origin path), closing the modal navigates here (e.g. stay on Medical Records). */
  returnTo?: string
}

type Opener = (teacher: Teacher, options?: OpenTeacherDetailsOptions) => void

let opener: Opener | null = null
let closer: (() => void) | null = null

export function registerTeacherDetailsModalHandlers(open: Opener, close: () => void) {
  opener = open
  closer = close
}

export function unregisterTeacherDetailsModalHandlers(open: Opener, close: () => void) {
  if (opener === open) opener = null
  if (closer === close) closer = null
}

export function openTeacherDetailsModal(teacher: Teacher, options?: OpenTeacherDetailsOptions) {
  opener?.(teacher, options)
}

export function closeTeacherDetailsModal() {
  closer?.()
}
